<template>
  <PaymentBox>
    <BoxContent
      title="Código não gerado"
      description="Clique em gerar novo código ou altere a forma de pagamento para continuar."
      icon="PixIcon"
      :animated="true"
      :success="false"
    >
      <div class="payment__buttons">
         <VButton @click.native="generateNewPix()" text="Gerar novo código Pix" />
         <VButton @click.native="goToPaymentMethods()" style="margin-top: 16px;" variant="tertiary" text="Alterar forma de pagamento" />
      </div>
    </BoxContent>
  </PaymentBox>
</template>

<script>
import PaymentBox from '@/components/layout/PaymentBox';
import BoxContent from '@/components/payments/BoxContent';

export default {
  name: 'PaymentPix',
  components: {
    PaymentBox,
    BoxContent,
  },
  data() {
    return {
      openDrawer: false
    };
  },
  methods: {
    generateNewPix() {
      return this.$router.push({ name: 'pix-payment' });
    },
    goToPaymentMethods() {
      return this.$router.push({ name: 'payment-methods' });
    }
  }
};
</script>

<style lang="scss" scoped>
   .payment__buttons {
      margin-top: 24px;
   }
   .payment__box-description {
      font-weight: 700;
      font-size: 16px;
      line-height: 150%;
   }
   .drawer__title {
   font-weight: 700;
   font-size: 20px;
   margin-bottom: 24px;
}

.drawer__list {
   color: #797C86;
   font-size: 16px;

   strong {
      font-weight: 700;
      display: block;
   }

   span {
      font-weight: 300;
   }

   li {
      display: block;
         margin-bottom: 24px;
   }
}
</style>
